import OrderView from "@/app/shared/ecommerce/order/order-view";
import PageHeader from "@/app/shared/page-header";
import routes from "@/routers/routes";
import { Link, useParams } from "react-router-dom";
import { Button } from "rizzui";

export default function OrderDetailsPage() {
    const { id } = useParams();

    const pageHeader = {
        title: `Order #${id}`,
        breadcrumb: [
            {
                href: routes.eCommerce.dashboard,
                name: "E-Commerce",
            },
            {
                href: routes.eCommerce.orders,
                name: "Orders",
            },
            {
                name: id,
            },
        ],
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb as any}
            >
                <Link
                    to={routes.eCommerce.editOrder(id!)}
                    className="mt-4 w-full @lg:mt-0 @lg:w-auto"
                >
                    <Button as="span" className="w-full @lg:w-auto ">
                        Edit Order
                    </Button>
                </Link>
            </PageHeader>
            <OrderView />
        </>
    );
}
